import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function OrderLookupPage() {
  const [orderNumber, setOrderNumber] = useState("");
  const [email, setEmail] = useState("");
  const nav = useNavigate();

  const onSubmit = (e) => {
    e.preventDefault();
    if (!orderNumber || !email) {
      toast.error("Enter order number and email");
      return;
    }
    nav(`/order/${orderNumber}?email=${encodeURIComponent(email)}`);
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="track-page">
      <div className="ipv-eyebrow text-[#0A1C40]">Tracking</div>
      <h1 className="font-display font-black text-4xl tracking-tighter mt-3">Track your order</h1>
      <p className="text-gray-600 mt-3 text-sm">
        Enter your order number and the email you used at checkout.
      </p>
      <form onSubmit={onSubmit} className="mt-8 space-y-4">
        <input
          className="input-base"
          placeholder="Order # (e.g. IPV-240315-XXXXX)"
          value={orderNumber}
          onChange={(e) => setOrderNumber(e.target.value)}
          data-testid="track-order-input"
        />
        <input
          className="input-base"
          type="email"
          placeholder="Email used at checkout"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="track-email-input"
        />
        <button className="btn-primary w-full" data-testid="track-submit-btn">
          Look up
        </button>
      </form>
    </div>
  );
}
